module.exports = __webpack_public_path__ + "h5/img/taptap.3d7b2daa.png";